// extracted by mini-css-extract-plugin
export default {"formHeading":"OK-z","form":"PK-z","submitBtn":"QK-z","disabled":"RK-z","input":"SK-z","error":"TK-z","submitMsg":"UK-z","signIn":"VK-z"};